import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  select(event) {
    if (event.key !== "Enter") return;

    const radio = event.currentTarget.querySelector('input[type="radio"]');
    if (!radio || radio.disabled) return;

    event.preventDefault();
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
